import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { ArquivoDiversoForm, ArquivoDiversoSchema } from "../../../schemas/AssistenciaTecnica_cadastro/arquivo_diverso";
import { DefaultFormFileInput } from "../../../../../../common/components/default_form_file_input";
import { useEffect, useMemo } from "react";
import { AssistenciaTecnicaArquivoLista } from "../../../../domain/models/assistencia_tecnica_arquivo_lista";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ArquivoDiversoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedArquivoDiverso: AssistenciaTecnicaArquivoLista | null;
  onClose: () => void;
  onSubmit: (form: ArquivoDiversoForm) => void;
  onDownload?: (idAssistenciaArquivo: number) => void;
};

export const ArquivoDiversoModal = ({
  open,
  saving,
  loading,
  selectedArquivoDiverso,
  onClose,
  onSubmit,
  onDownload,
}: Props) => {

  const hookForm = useForm<ArquivoDiversoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ArquivoDiversoSchema),
  });

  const [arquivo, limparArquivo] = hookForm.watch(['arquivo', 'limparArquivo']);

  const arquivoNome = useMemo(() => selectedArquivoDiverso?.nome ?? undefined, [
    selectedArquivoDiverso,
  ]);

  useEffect(() => {
    if (open) {
      if (selectedArquivoDiverso) {
        hookForm.setValue('descricao', selectedArquivoDiverso.descricao ?? '');
        hookForm.setValue('arquivo', null);
        hookForm.setValue('limparArquivo', false);
      } else {
        hookForm.reset({ limparArquivo: false });
      }
    }
  }, [
    open,
    selectedArquivoDiverso,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Arquivo"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 my-4">
        <DefaultFormInput
          name='descricao'
          label='Nome do Arquivo'
          reactHookForm={hookForm}
        />

        <DefaultFormFileInput
          name='arquivo'
          saving={saving}
          loading={loading}
          filename={arquivo === null && !limparArquivo ? arquivoNome : undefined}
          maxFilenameLength={100}
          reactHookForm={hookForm}
          onDownload={_ => {
            if (selectedArquivoDiverso && onDownload) {
              onDownload(selectedArquivoDiverso.idAssistenciaArquivo);
            }
          }}
          onChangeFile={() => hookForm.setValue('limparArquivo', false)}
          onLimparArquivo={() => {
            hookForm.setValue('arquivo', null);
            hookForm.setValue('limparArquivo', true);
          }}
        />
      </div>
    </BaseFormControlledModal>
  );
}